export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url("https://public.readdy.ai/ai/img_res/5a4b19b38aa9146991f9eb06da5fa70f.jpg")'
        }}
      ></div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="mb-8">
          <span className="inline-block bg-[#FF6B4A] text-white px-6 py-3 rounded-full text-sm font-bold uppercase tracking-wider">
            100% Performance Guarantee
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white mb-8 leading-tight">
          30 Clients in 60 Days<br />
          <span className="text-[#FF6B4A]">Or We Write You a $1,000 Check</span>
        </h1>

        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto font-light">
          The only marketing agency for detailers that guarantees results. 
          No leads? No charge. It's that simple.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
          <a
            href="https://calendly.com/detailerx-agencys/detailerx-discovery-call"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#FF6B4A] text-white px-10 py-5 rounded-lg text-xl font-bold hover:bg-[#ff5a39] transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Book Strategy Call
          </a>
          <a
            href="#guarantee"
            className="bg-white/10 backdrop-blur-sm text-white px-10 py-5 rounded-lg text-xl font-bold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            See Our Guarantee
          </a>
        </div>

        {/* Single Stat Card */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
            <div className="text-6xl font-black mb-2">
              <span className="text-[#FF6B4A]">$10,000</span>
            </div>
            <div className="text-white/90 text-lg font-medium">
              Average client sees extra revenue within their first month
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/70"></i>
      </div>
    </section>
  );
}
